'use strict';

module Patersons {

  export class ChangePhoneComponent implements ng.IComponentOptions {
    templateUrl: string = 'assets/templates/common/components/changePhone.component.html';
    controller: any = ChangePhoneCtrl;
    bindings: any = {
      showCancelButton: '<',
    };
  }

  export interface ChangePhoneScope extends ng.IScope {
    showInfo: boolean;
    showCancelButton: boolean;
    currentNumber: string;
    changePhoneForm: ng.IFormController;
    verifyPhoneForm: ng.IFormController;
    phoneDetails: Patersons.PhoneDetails;
    phoneConfirmationDetails: Patersons.PhoneConfirmationDetails;
    errorHandler: any;
    isCodeSubmitted: boolean;
    events: Patersons.ChangePhoneCtrl;
    userCompany: UserCompany;
    profile: UserProfile;
  }

  export class ChangePhoneCtrl {
    scope: Patersons.ChangePhoneScope;
    window: ng.IWindowService;
    state: angular.ui.IStateService;
    stateParams: angular.ui.IStateProvider;
    identityService: Patersons.IdentityService;
    tokenService: Patersons.TokenService;
    navigationService: Patersons.NavigationService;
    sessionService: Patersons.SessionService;
    showCancelButton: boolean;
    location: angular.ILocationService;

    static $inject = ['$scope', '$location', '$window', '$state', '$stateParams', 'identityService', 'tokenService', 'navigationService', 'userCompanyService', 'sessionService'];

    constructor($scope, $location, $window, $state, $stateParams, identityService, tokenService, navigationService, userCompanyService, sessionService) {
      this.scope = $scope;
      this.window = $window;
      this.state = $state;
      this.stateParams = $stateParams;
      this.identityService = identityService;
      this.tokenService = tokenService;
      this.navigationService = navigationService;
      this.location = $location;
      this.sessionService = sessionService;
      this.scope.profile = this.sessionService.getCurrentUserProfile();

      this.scope.events = this;
      this.scope.showCancelButton = this.showCancelButton;
      var userId = $stateParams.userId;
      this.scope.isCodeSubmitted = false;
      this.scope.phoneDetails = {
        mobilePhoneNumber: ""
      } ;
      this.navigationService.deactivateAll();
      this.updateUiFromProfile();
      userCompanyService.getUserCompany().then((company) => {
        this.scope.userCompany = company;
      })
    }

    updateUiFromProfile() {
      //let profile = this.tokenService.tokenManager.profile;

      //if (profile) {
        //this.scope.showInfo = (profile.phone_number_verified != "true");
        //this.scope.currentNumber = profile.phone_number;
        // get phone number from backend
        var promise = this.identityService.getPhoneNumber();
        promise.then((result: any) => {
          this.scope.showInfo = (result["phoneNumberVerified"] != true);
          this.scope.currentNumber = result["phoneNumber"];
          this.scope.phoneDetails = {
            mobilePhoneNumber: this.scope.currentNumber
          }
          console.log(this.scope.currentNumber);
          console.info('this.scope.showInfo ' + this.scope.showInfo);
          console.info('this.scope.currentNumber ' + this.scope.currentNumber);
        }).catch((reason) =>{
          this.scope.showInfo = true;
          console.error(reason);
        });
      //} else {
      //  this.scope.showInfo = true;
      //}
    }

    changeNumber() {
      this.scope.$broadcast('show-errors-check-validity');

      if (this.scope.changePhoneForm.$invalid) {
        return;
      }
      this.identityService.changeMobileNumber(this.scope.phoneDetails)
        .then((result) => {
          this.scope.isCodeSubmitted = true;
        },
        (reason) => {
          this.scope.errorHandler = reason.data;
        });
    }

    confirmCode() {
      this.scope.$broadcast('show-errors-check-validity');

      if (this.scope.verifyPhoneForm.$invalid) {
        return;
      }

      this.scope.phoneConfirmationDetails.mobilePhoneNumber = this.scope.phoneDetails.mobilePhoneNumber;

      this.identityService.confirmMobileNumberChange(this.scope.phoneConfirmationDetails)
        .then((result) => {
          this.scope.showInfo = false;
          this.scope.currentNumber = this.scope.phoneConfirmationDetails.mobilePhoneNumber;
          setTimeout(() => {
              location.href = '/dashboard';
          }, 2000);
          // need to avoid that redirect
          //this.tokenService.tokenManager.redirectForToken();
        },
          (reason) => {
            this.updateUiFromProfile();
            this.scope.errorHandler = reason.data;
          });
    }

    cancelRegistration(): void {
      location.href = '/dashboard';
    }
  }
}
